import { Edit, useRedirect, useRefresh } from "react-admin";
import { useNotification } from "../../../common/hooks/useNotification";
import { useQueryParams } from "../../../common/hooks/useQueryParams";
import { EventMasterForm } from "./EventMasterForm";
import { EventMasterFormActions } from "./EventMasterFormActions";

interface Props {}

export const EditEvent = (props: Props) => {
  const notify = useNotification(props, "editSuccess");
  const redirect = useRedirect();
  const refresh = useRefresh();
  const params = useQueryParams();
  const source = JSON.parse(params.get("source") ?? "{}");
  const driverId = source.driverId;
  const date = source.date;

  const handleSuccess = (args: any) => {
    notify(args);
    redirect(`/hos-driver-log-view/${driverId}/${date}`);
    refresh();
  };

  return (
    <Edit
      mutationMode="pessimistic"
      {...props}
      actions={<EventMasterFormActions />}
      onSuccess={handleSuccess}
      title="Edit a status event"
    >
      <EventMasterForm isEdit />
    </Edit>
  );
};
